const func = $target => {

    let $redirectLink = $target.find('.redirect-link').html(),
        array = [];
    window.addEventListener('message', event => {
        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
            const fields = ['firstname', 'lastname', 'email', 'country'];
            event.data.data.forEach(x => {
                let found = fields.find(y => y === x.name);
                if (found) {
                    let object = {
                        name: found,
                        value: x.value
                    };
                    array.push(object);
                }
            });
        }
        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
            let firstname = array.find(x => x.name === 'firstname').value;
            let lastname = array.find(x => x.name === 'lastname').value;
            let email = array.find(x => x.name === 'email').value;
            let country = array.find(x => x.name === 'country').value;

            setTimeout(function () {
                window.location.href = $redirectLink + '?firstname=' + firstname + '&lastname=' + lastname + '&country=' + country + '&email=' + email + '';
            }, 1500)
        }
    });
    window.addEventListener("message", event => {
        if (event.data.meetingBookSucceeded === true) {
            $("ul li:nth-child(3)").addClass('active')
            $(".book-meeting").addClass('d-none')
            $(".confirmation").removeClass('d-none');
        }
    });
}
export default func;